import axios from 'axios';
import toast from 'react-hot-toast';
import { getFreshToken } from './authTokenProvider';

const apiBaseUrl = process.env.REACT_APP_API_URL || '/api';

export const unwrapList = (data) =>
  Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];

const api = axios.create({
  baseURL: apiBaseUrl,
  timeout: 15000,
});

api.interceptors.request.use(async (config) => {
  const token = await getFreshToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config || {};
    const status = err.response?.status;

    if ((status === 401 || status === 403) && !original._retried) {
      original._retried = true;
      const token = await getFreshToken();
      if (token) {
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${token}`;
        return api(original);
      }
    }

    if (status === 401 && !window.location.pathname.startsWith('/sign-')) {
      window.location.href = '/sign-in';
    }

    const msg = err.response?.data?.detail || err.response?.data?.message || 'Something went wrong';
    if (status !== 401 && status !== 403) toast.error(msg);
    return Promise.reject(err);
  }
);

export default api;